var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBurger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4444 13.5556H32.5556M11.4444 22H32.5556M11.4444 30.4444H32.5556M7.22222 3H36.7778C39.1096 3 41 4.89035 41 7.22222V36.7778C41 39.1096 39.1096 41 36.7778 41H7.22222C4.89035 41 3 39.1096 3 36.7778V7.22222C3 4.89035 4.89035 3 7.22222 3Z",
    stroke: "#242A40",
    strokeWidth: 4.22222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurger);
export default __webpack_public_path__ + "static/media/Burger.d2a9ad7e0cc08be31b51979c76029308.svg";
export { ForwardRef as ReactComponent };